import { Component, Input, OnInit, OnDestroy, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { embedDashboard } from '@superset-ui/embedded-sdk';
import { SupersetDashboardService } from '../../superset-dashboard/service/superset-dashboard.service';
import { SidePanelService } from '../services/side-pannel/side-pannel.service';

@Component({
  selector: 'app-embedded-superset',
  templateUrl: './embedded-superset.component.html',
  styleUrls: ['./embedded-superset.component.scss']
})
export class EmbeddedSupersetComponent implements OnInit, OnDestroy, OnChanges {
  private isInitalized: boolean = false;

  @Input() dashboardId: string;
  @Input() dashboardName: string;
  @Input() studyUUID: string;
  @Input() type: string;
  @Input() height: string = '100%';
  @Input() supersetDomain: string = 'https://bi.crownit.in';

  @ViewChild('supersetContainer', { static: true })
  supersetContainer!: ElementRef;

  isLoading: boolean = false;
  hasError: boolean = false;
  errorMessage: string = '';

  constructor(
    private supersetDashboardService: SupersetDashboardService,
    private SidePanelService: SidePanelService
  ) { }

  ngOnInit(): void {
    if (this.dashboardId) {
      this.loadDashboard();
    }
    this.isInitalized = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Skip changes before ngOnInit (ngOnInit handles initial load)
    if (!this.isInitalized) {
      return;
    }

    if (changes['dashboardId'] || changes['dashboardName']) {
      this.clearContainer();
      if (this.dashboardId) {
        this.loadDashboard();
      }
    }
  }

  ngOnDestroy(): void {
    this.clearContainer();
  }

  private clearContainer(): void {
    if (this.supersetContainer?.nativeElement) {
      this.supersetContainer.nativeElement.innerHTML = '';
    }
  }

  private loadDashboard(): void {
    this.isLoading = true;
    this.hasError = false;
    this.errorMessage = '';
    let body = {};
    body = {
      dash_id: this.dashboardId,
      type: this.type,
      dash_name: this.dashboardName,
    };
    if(this.type === 'studyLevel'){
      body['study_uuid'] = this.dashboardId;
      if(localStorage.getItem('dash_suite_uuid')){
        body['dash_id'] = localStorage.getItem('dash_suite_uuid');
      }
    }
    this.supersetDashboardService.getAuthGuestToken(body).subscribe({
      next: async (res: any) => {
        if (res && res.status) {
          try {
            await embedDashboard({
              id: res.dash_id,
              supersetDomain: this.supersetDomain,
              mountPoint: this.supersetContainer.nativeElement,
              fetchGuestToken: () => Promise.resolve(res.token)
            });
            this.isLoading = false;
          } catch (error) {
            this.handleError('Failed to embed dashboard');
          }
        } else {
          this.handleError(res?.message || 'Failed to get authentication token');
        }
      },
      error: (err) => {
        this.handleError(err?.message || 'Failed to load dashboard');
      }
    });
  }

  private handleError(message: string): void {
    this.isLoading = false;
    this.hasError = true;
    this.errorMessage = message;
  }

  /**
   * Public method to reload the dashboard
   */
  reload(): void {
    this.clearContainer();
    if (this.dashboardId) {
      this.loadDashboard();
    }
  }
}
